import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Col, Row } from "antd";

import colors from "../styles/globalColors";
import { Link } from "react-router-dom";

export default (props: {
  label: string;
  value: string | number | undefined;
  datavalue?: number | 0;
  link?: string;
  placeholder?: string;
  horizontal?: boolean;
  labelStyles?: any;
  containerStyles?: any;
}) => {
  const {
    label,
    value,
    link,
    placeholder,
    horizontal,
    labelStyles,
    containerStyles,
    datavalue
  } = props;

  if (horizontal) {
    return (
      <Row type="flex" justify="space-between" style={containerStyles}>
        <Col css={[styles.label, labelStyles]}>{label}</Col>
        <Col>{value || placeholder || ""}</Col>
      </Row>
    );
  }

  return (
    <div style={containerStyles}>
      <p css={[styles.label, labelStyles]}>{label}</p>
      {link && value ? (
        <p>
          <Link to={link}>{value}</Link>
        </p>
      ) : (
        <p>{value || placeholder || ""}</p>
      )}
    </div>
  );
};

const styles = {
  label: {
    color: colors.textGray,
    marginBottom: 3
  }
};
